import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import axe from '../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../services/axios-client/axeHelpers';
import pdfIMG from '../../../assets/images/purchase/pdf.png';
import downloadIMG from '../../../assets/redesign_icons/download.svg';
import {
  CompletedCard,
  CompletedCardHeader,
  CompletedCardIcon,
  CompletedCardTitle,
} from '../../../screens/CompletedQuotes/CompletedV2.styles';

function CompletedScreenOfflineDocuments({
  rc_quotation,
  insuranceRequest,
  downloadDocument,
}) {
  const downloadInvoice = async (quoteId, payment_number) => {
    const res = await axe.get(`/list/invoices/${quoteId}/download/${payment_number}`, {
      responseType: 'blob',
    });
    const contentDisposition = res.headers['content-disposition'];
    const file_name = contentDisposition.split('filename="')[1].split('"')[0];
    downloadFile(res.data, file_name);
  };

  return (
    <>
      <div className="col-12 mt-4">
        <CompletedCard className="mb-3 polizze-emessa-status-step-four">
          <CompletedCardHeader>
            <CompletedCardIcon>
              <FontAwesomeIcon icon={faFolderOpen} />
            </CompletedCardIcon>
            <CompletedCardTitle>Documenti</CompletedCardTitle>
          </CompletedCardHeader>
          <div className="documents-body">
            <ul className="documents-list">
              {insuranceRequest.documents.filter((dr) => dr.signable_document === 0).map((document, index) => (
                <li className="document-item" key={index}>
                  <div className="document-content flex-column">
                    <div className="document-name">
                      {document.document_type_id === 13
                        && insuranceRequest.quotation_renewal_request !== null
                        ? 'Rinnovo'
                        : document.document_type.name}
                    </div>
                    <div className="document-actions flex-row">
                      <div className="file-info">
                        <img
                          src={pdfIMG}
                          className="img-fluid"
                          width="25"
                          alt="PDF"
                        />
                        <span className="file-name">
                          {document.original_filename}
                        </span>
                      </div>
                      <button
                        className="doc-btn border-0 bg-transparent"
                        onClick={() => downloadDocument(document.id)}
                      >
                        <img src={downloadIMG} width="25" alt="Scarica" />
                      </button>
                    </div>
                    {document.signable_document === 1
                      && document.is_signed_valid === 0
                      && document.signed_document_filename === null
                      && document.motivation !== null && (
                        <div className="document-motivation">
                          {document.motivation}
                        </div>
                    )}
                  </div>
                  {document.signable_document === 1 && (
                    <div className="document-status">
                      {document.is_signed_valid === null
                        && document.signed_document_filename !== null ? (
                          <span className="status-badge status-warning">
                            In Verifica
                          </span>
                        ) : document.is_signed_valid === 0 ? (
                          <span className="status-badge status-danger">
                            Firma Non Valida
                          </span>
                        ) : document.is_signed_valid === null
                        && document.signed_document_filename === null ? (
                          <span className="status-badge status-warning">
                            Da Firmare
                          </span>
                          ) : document.is_signed_valid === 1
                        && document.signed_document_filename !== null ? (
                          <span className="status-badge status-success">
                            Firmato
                          </span>
                            ) : null}
                    </div>
                  )}
                  {document.signable_document !== 1 && (
                    <div className="document-status">
                      <span className="status-badge status-info">
                        Non Richiede Firma
                      </span>
                    </div>
                  )}
                </li>
              ))}
              {/* {rc_quotation.documents.map((document, index) => (
                <li
                  className="list-group-item d-flex justify-content-between align-items-start"
                  key={index}
                >
                  <div className="ms-2 me-auto">
                    <div className="fw-bold mb-2">
                        {document.document_type.name}
                      </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <img
                            src={pdfIMG}
                            className="img-fluid"
                            width="25"
                            alt="PDF"
                          />
                        <div className="mx-2">
                            <h5 className="h6 mb-0">
                                {document.original_filename}
                              </h5>
                          </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <button
                                className="doc-btn border-0 bg-transparent"
                                onClick={() => downloadDocument(document.id)}
                              >
                                <img src={downloadIMG} width="25" alt="" />
                              </button>
                          </div>
                        {document.signable_document === 1
                                                && (document.is_signed_valid === 0
                                                    || (document.is_signed_valid === null
                                                        && document.signed_document_filename === null)) && (
                                                        <ActionsWrapperResultPage>
                                                          {' '}
                                                          {([13, 35, 36, 37, 38, 39, 40, 41].includes(document.document_type.id)) && (
                                                          <div
                                                            className="action-button"
                                                            onClick={() => fireSignedDocUpload(document.document_type_id)}
                                                          >
                                                            <img src={uploadIcon} alt="" width={25} />
                                                            <input
                                                              ref={uploadPolizzaEmessa}
                                                              type="file"
                                                              name=""
                                                              id=""
                                                              className="d-none"
                                                              onChange={(e) => uploadSignedDocument(
                                                                document.id,
                                                                e.target.files,
                                                              )}
                                                            />
                                                          </div>
                                                          )}
                                                          {document.document_type.id === 32 && (
                                                          <div
                                                            className="action-button"
                                                            onClick={() => fireSignedDocUpload(document.document_type_id)}
                                                          >
                                                            <img src={uploadIcon} alt="" width={25} />
                                                            <input
                                                              ref={uploadQuietanzaSemestrale}
                                                              type="file"
                                                              name=""
                                                              id=""
                                                              className="d-none"
                                                              onChange={(e) => uploadSignedDocument(
                                                                document.id,
                                                                e.target.files,
                                                              )}
                                                            />
                                                          </div>
                                                          )}
                                                          {document.document_type.id === 29 && (
                                                          <div
                                                            className="action-button"
                                                            onClick={
                                                                    document.signed_document_filename === null
                                                                      ? () => fireSignedDocUpload(
                                                                        document.document_type.id,
                                                                      )
                                                                      : () => { }
                                                                }
                                                          >
                                                            <img src={uploadIcon} alt="Carica" width={25} />
                                                            <input
                                                              ref={uploadPreContractRef}
                                                              type="file"
                                                              name=""
                                                              id=""
                                                              className="d-none"
                                                              onChange={(e) => uploadSignedDocument(
                                                                document.id,
                                                                e.target.files,
                                                              )}
                                                            />
                                                          </div>
                                                          )}
                                                          {document.document_type.id === 28 && (
                                                          <div
                                                            className="action-button"
                                                            onClick={
                                                                    document.signed_document_filename === null
                                                                      ? () => fireSignedDocUpload(
                                                                        document.document_type.id,
                                                                      )
                                                                      : () => { }
                                                                }
                                                          >
                                                            <img src={uploadIcon} alt="Carica" width={25} />
                                                            <input
                                                              ref={uploadDichiarazioniDocRef}
                                                              type="file"
                                                              name=""
                                                              id=""
                                                              className="d-none"
                                                              onChange={(e) => uploadSignedDocument(
                                                                document.id,
                                                                e.target.files,
                                                              )}
                                                            />
                                                          </div>
                                                          )}
                                                          {document.document_type.id === 30 && (
                                                          <div
                                                            className="action-button"
                                                            onClick={
                                                                    document.signed_document_filename === null
                                                                      ? () => fireSignedDocUpload(
                                                                        document.document_type.id,
                                                                      )
                                                                      : () => { }
                                                                }
                                                          >
                                                            <img src={uploadIcon} alt="Carica" width={25} />
                                                            <input
                                                              ref={uploadQuestionarioAutoDocRef}
                                                              type="file"
                                                              name=""
                                                              id=""
                                                              className="d-none"
                                                              onChange={(e) => uploadSignedDocument(
                                                                document.id,
                                                                e.target.files,
                                                              )}
                                                            />
                                                          </div>
                                                          )}
                                                          {document.optional_document_request_id && (
                                                          <div
                                                            className="action-button"
                                                            onClick={
                                                                    document.signed_document_filename === null
                                                                      ? () => fireSignedDocUpload(
                                                                        document.document_type.id,
                                                                        document.id,
                                                                      )
                                                                      : () => { }
                                                                }
                                                          >
                                                            <img src={uploadIcon} alt="Carica" width={25} />
                                                            <input
                                                              ref={optionalRefs[document.id]}
                                                              type="file"
                                                              name=""
                                                              id=""
                                                              className="d-none"
                                                              onChange={(e) => uploadSignedOptionalDocument(
                                                                document.id,
                                                                e.target.files,
                                                              )}
                                                            />
                                                          </div>
                                                          )}
                                                          {document.document_type.id === 12 && (
                                                          <div
                                                            className="action-button"
                                                            onClick={
                                                                    document.signed_document_filename === null
                                                                      ? () => fireSignedDocUpload(
                                                                        document.document_type.id,
                                                                      )
                                                                      : () => { }
                                                                }
                                                          >
                                                            <img src={uploadIcon} alt="Carica" width={25} />
                                                            <input
                                                              ref={uploadPrivacyRef}
                                                              type="file"
                                                              name=""
                                                              id=""
                                                              className="d-none"
                                                              onChange={(e) => uploadSignedDocument(
                                                                document.id,
                                                                e.target.files,
                                                              )}
                                                            />
                                                          </div>
                                                          )}
                                                        </ActionsWrapperResultPage>
                          )}
                      </div>
                    {document.signable_document === 1
                                            && document.is_signed_valid === 0
                                            && document.signed_document_filename === null
                                            && document.motivation !== null && (
                                            <p className="text-danger mt-2">
                                              {document.motivation}
                                            </p>
                      )}
                  </div>
                  <div>
                    {document.signable_document === 1 ? (
                        document.is_signed_valid === null
                                                && document.signed_document_filename !== null ? (
                                                  <span className="badge bg-warning rounded-pill position-absolute top-25 end-0 me-2">
                                                    In Verifica
                                                  </span>
                          ) : document.is_signed_valid === 0 ? (
                              <span className="badge bg-danger rounded-pill position-absolute top-25 end-0 me-2">
                                  Firma Non Valida
                                              </span>
                          ) : document.is_signed_valid === null
                                                && document.signed_document_filename === null ? (
                                                  <span className="badge bg-warning rounded-pill position-absolute top-25 end-0 me-2">
                                                    Da Firmare
                                                  </span>
                            ) : document.is_signed_valid === 1
                                                && document.signed_document_filename !== null ? (
                                                  <span className="badge bg-primary rounded-pill position-absolute top-25 end-0 me-2">
                                                    Firmato
                                                  </span>
                              ) : null
                      ) : (
                          <span className="badge bg-info rounded-pill position-absolute top-25 end-0 me-2">
                              Non Richiede Firma
                                          </span>
                      )}
                    {' '}
                  </div>
                </li>
              ))} */}
              {rc_quotation.quote_type === 'res_civile'
                && rc_quotation.payments.length > 0 && rc_quotation.payments.map((payment, paymentIndex) => (
                  <li className="document-item" key={`invoice-${paymentIndex}`}>
                    <div className="document-content flex-column">
                      <div className="document-name">
                        {rc_quotation.payments.length > 1
                          ? `Fattura ${paymentIndex + 1}`
                          : 'Fattura'}
                      </div>
                      <div className="document-actions flex-row">
                        <div className="file-info">
                          <img
                            src={pdfIMG}
                            className="img-fluid"
                            width="25"
                            alt="PDF"
                          />
                          <span className="file-name">Scarica Fattura</span>
                        </div>
                        <button
                          className="doc-btn border-0 bg-transparent"
                          onClick={() => downloadInvoice(rc_quotation.id, paymentIndex + 1)}
                        >
                          <img src={downloadIMG} width="25" alt="Scarica" />
                        </button>
                      </div>
                    </div>
                    <div className="document-status">
                      <span className="status-badge status-info">
                        Non Richiede Firma
                      </span>
                    </div>
                  </li>
              ))}
            </ul>
          </div>
        </CompletedCard>
      </div>
    </>
  );
}

export default CompletedScreenOfflineDocuments;
